import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { PrimaryButton, TextInput, MiniButton } from "../components/UIkit";
import { resetPassword } from "../reducks/users/operations";
import { push } from "connected-react-router";
import "../assets/css/basicForm.css";
import { HeaderMenu } from "../components/header";

const Reset = () => {
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const isLoginPage = true;

  const inputEmail = useCallback(
    (event) => {
      setEmail(event.target.value);
    },
    [setEmail]
  );

  const validateEmailFormat = (email) => {
    // const regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return regex.test(email);
  };
  const validateRequiredInput = (...args) => {
    let isBlank = false;
    for (let i = 0; i < args.length; i = (i + 1) | 0) {
      if (args[i] === "") {
        isBlank = true;
      }
    }
    return isBlank;
  };

  const submitReset = () => {
    const isBlank = validateRequiredInput(email);
    const isValidEmail = validateEmailFormat(email);
    if (isBlank) {
      alert("メールアドレスが空白です");
      return false;
    } else if (!isValidEmail) {
      alert("メールアドレスの書式が異なります");
      return false;
    } else {
      dispatch(resetPassword(email));
    }
  };

  return (
    <div className="common-container">
      <div className="common-container__header--inner center-box">
        <HeaderMenu isLoginPage={isLoginPage} />

        <h2 className="meiryo form-text__headline--m center">パスワードのリセット</h2>
        <div className="form-container center-box">
          <div className="spacer-box--m" />
          <div className="input-wide--basic center-box">
            <TextInput
              fullWidth={true}
              label={"メールアドレス"}
              multiline={false}
              required={true}
              rows={1}
              value={email}
              type={"email"}
              onChange={inputEmail}
            />
          </div>
          <div className="spacer-box--l" />
          <div className="center">
            <PrimaryButton label={"リセット"} onClick={() => submitReset()} />
            <div className="spacer-box--s" />
            <p className="form-text__guide hover1" onClick={() => dispatch(push("/signin"))}>
              ログインに戻る
            </p>
            <div className="spacer-box--s" />
            <MiniButton label="ブース一覧へ" onClick={() => dispatch(push("/boothlist"))} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Reset;
